module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightbar"
  }, [_c('div', {
    staticClass: "close iconfont",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("")]), _c('div', {
    staticClass: "menu"
  }, [_c('transition', {
    attrs: {
      "name": "bottom-up",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].menu))])]), _c('transition-group', {
    attrs: {
      "appear": "appear",
      "tag": "ul"
    },
    on: {
      "before-appear": _vm.beforeEnter,
      "appear": _vm.enter
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('router-link', {
      key: "index",
      attrs: {
        "tag": "li",
        "data-index": index,
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title[_vm.lang]))])
  }), 1), _c('transition', {
    attrs: {
      "name": "top-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "lang"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleLang('zh')
      }
    }
  }, [_vm._v("中文")]), _vm._v("/"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleLang('en')
      }
    }
  }, [_vm._v("EN")])])])], 1), (_vm.lang === 'zh') ? _c('transition', {
    attrs: {
      "name": "top-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "declare"
  }, [_c('b', [_vm._v("【严正声明】")]), _c('p', [_vm._v("近日，我们收到网友举报，有人冒用贝塔斯曼及BAI名义，通过APP、微信群等渠道发布虚假信息，以保本高息产品为诱导，以投资、理财、资本募集等形式开展诈骗活动。这些诈骗行为不仅严重影响了BAI的企业声誉，也造成了相关受众的经济损失。")]), _c('p', [_c('b', [_vm._v("我们在此严正声明：")])]), _c('p', [_vm._v("我公司从未授权任何机构使用“贝塔斯曼”或“BAI”品牌或商标开展任何面向消费者的经营活动。我公司从未开发、运营、冠名过任何APP，且从未授权任何机构开发任何APP，所有网站、应用商店中使用我公司商标、商号、品牌名称的APP均为非法冒用。我公司从未通过组织微信群、QQ群或任何其他渠道公开发布融资信息、组织募资、募捐活动或开展任何诱导消费者投资、缴费入会活动。我公司员工从未以个人名义或以公司名义进行过任何公开融资、募资、募捐或售卖会员资格活动。")]), _c('p', [_vm._v("请公众切勿轻信任何以我公司或我司人员名义发起的融资、募资、募捐、个人投资理财、会员资格购买活动。如遭受损失，我们建议消费者注意保留汇款记录、聊天记录、电话录音等证据，并立即向当地公安机关报案或者登陆网络违法犯罪举报网站举报(网址：http://cyberpolice.mps.gov.cn )。")]), _c('p', [_vm._v("对于冒充贝塔斯曼、BAI或我公司合作机构工作人员的行为，一经核实，我们将追究法律责任。请公众提高警惕，如有任何疑问，请通过以下官方渠道与我们进行预先核实确认：")]), _c('b', [_vm._v("【联络邮箱】")]), _c('li', [_vm._v("bp@bertelsmann.com")]), _c('br'), _c('b', [_vm._v("【官方网站】")]), _c('li', [_c('a', {
    attrs: {
      "href": "http://baifund.com/#/"
    }
  }, [_vm._v("http://baifund.com/#/")])]), _c('br'), _c('b', [_vm._v("【官方微信公众号】")]), _c('li', [_vm._v("bertelsmannchina")])])]) : _c('transition', {
    attrs: {
      "name": "top-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "declare"
  }, [_c('b', [_vm._v("【Statement】")]), _c('p', [_vm._v("Recently, BAI (Bertelsmann Asia Investments) received reports that someone has unlawfully used names such as “Bertelsmann Fund” and “Arnold Bahlmann” (hereinafter collectively referred to as \"BAI\") to publish false information through channels including APP, WeChat Group, etc., misleading users with principal-guaranteed and high-interest-bearing products, to conduct fraudulent activities in various form such as investment, wealth management and capital raising. Such fraudulent activities not only severely affected BAI's reputation, but also caused economic losses to investors.")]), _c('p', [_c('b', [_vm._v("BAI hereby solemnly declares:")])]), _c('p', [_vm._v("BAI has never released any APP, nor authorized any entity or individual to conduct any fund-raising activities on behalf of BAI.")]), _c('p', [_vm._v("To avoid unnecessary losses, please do not trust such false information and kindly contact us for confirmation when receiving any such information. If the public encounters such persons or behaviors, please immediately report the case and provide evidence at the local police station to minimize losses and recover funds.")]), _c('p', [_vm._v("Any acts of impersonating the staff of BAI or BAI’s cooperation organization, once verified, will be pursued legal responsibilities. The public is requested to be vigilant. If you have any questions, please confirm with us through the following official channels:")]), _c('b', [_vm._v("【Emails】")]), _c('li', [_vm._v("For BP：bp@bertelsmann.com")]), _c('li', [_vm._v("For career：hr@bertelsmann.com")]), _c('br'), _c('b', [_vm._v("Website")]), _c('li', [_c('a', {
    attrs: {
      "href": "http://baifund.com/#/"
    }
  }, [_vm._v("http://baifund.com/#/")])]), _c('br'), _c('b', [_vm._v("Wechat Account")]), _c('li', [_vm._v("ID：BAI_VC")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517908fc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rightbar.vue
// module id = 511
// module chunks = 1